import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ptBR from '@/locales/pt-BR.json'

Vue.use(VueI18n)

const loadedLanguages = ['pt-BR']

const i18n = new VueI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: { 'pt-BR': ptBR },
  silentTranslationWarn: true,
})

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.documentElement.setAttribute('lang', lang)
  return lang
}

/**
 * Lazy-loads a locale bundle and activates it.
 * Safe to call multiple times — already-loaded locales are skipped.
 * @param {string} lang  locale code: 'pt-BR' | 'en' | 'es'
 */
export async function loadLanguageAsync (lang) {
  const target = lang || 'pt-BR'
  if (i18n.locale === target && loadedLanguages.includes(target)) return target
  if (loadedLanguages.includes(target)) return setI18nLanguage(target)
  const msgs = await import(/* webpackChunkName: "locale-[request]" */ `@/locales/${target}.json`)
  i18n.setLocaleMessage(target, msgs.default)
  loadedLanguages.push(target)
  return setI18nLanguage(target)
}

/** Backend Language enum value → vue-i18n locale code */
export const BACKEND_TO_LOCALE = {
  PT_BR: 'pt-BR',
  EN: 'en',
  ES: 'es',
}

/** vue-i18n locale code → Backend Language enum value */
export const LOCALE_TO_BACKEND = {
  'pt-BR': 'PT_BR',
  en: 'EN',
  es: 'ES',
}

export default i18n
